import {sitePdfUrl} from '../../utils'
import {trackClick} from '../../utils/trackEvent'

function PDFButton({pdfLink, articleId}) {
    return (
        <div className="flex flex-row mx-2 my-2 noprint">
            <a className="block w-32 h-16 px-4 py-2 cursor-pointer text-xl mx-2 my-2 font-semibold text-center text-white border-0 border-indigo-400 rounded sm:max-w-sm max-h-12 noprint bg-oijpcr-blue focus:outline-none"
               href={sitePdfUrl(pdfLink)} target="_blank"
               onClick={() => trackClick(articleId, 'pdf')}
               rel="noreferrer"
            >
                PDF
            </a>
        </div>)
}

function PDFButtonSmall({pdfLink, articleId}) {
    return (
        <div className="flex flex-row noprint">
            <a className="inline-flex items-center px-4 py-2.5 my-4 mr-4 text-white rounded-lg bg-oijpcr-blue sm:my-2 max-w-max focus:outline-none noprint"
               href={sitePdfUrl(pdfLink)} target="_blank"
               onClick={() => trackClick(articleId, 'pdf')}
               rel="noreferrer"
            >
                PDF
            </a>
        </div>)
}


export {PDFButton, PDFButtonSmall}
